import React from "react";

const Login = () => {
  return <h1>Desde login</h1>;
};

export default Login;
